/**
 * i18n messages for the User model.
 *
 * Both functional getters and eagerly-evaluated arrays are exported.
 * The arrays preserve API compatibility with existing JS consumers
 * that read `ModelErrors` / `ModelSuccess` directly. New code should
 * prefer the `getModelErrors()` / `getModelSuccess()` getters so that
 * translations are resolved on call rather than at module load.
 */

import i18next from 'app/translations/i18n';
import type { ModelErrorEntry, ModelMessage } from '../_shared.types';

export const getModelErrors = (): ModelErrorEntry[] => [
  { errorKey: 'USERNAME_EXIST', message: i18next.t('users:error_user_exist') },
  { errno: 1062, message: i18next.t('users:error_user_exist') },
];

export const getModelSuccess = (): ModelMessage[] => [
  { id: 'create', message: i18next.t('toast:toast_create') },
  { id: 'update', message: i18next.t('toast:toast_update') },
];

/**
 * Localized label for a role. Lazy by design: i18next must be ready
 * by the time this is called.
 */
export function getRoleText(roleGuid: string): string {
  return i18next.t(`users:${roleGuid}`);
}

// Backwards-compatible eager exports. Resolved at module load time,
// like the original user.js, so existing imports keep working.
export const ModelErrors: ModelErrorEntry[] = getModelErrors();
export const ModelSuccess: ModelMessage[] = getModelSuccess();
